export namespace IAccounts {
  export enum Action {
    PersonsMk = 'PersonsMk',
  }

  export enum Command {
    Get = 'get',
    Create = 'create',
    Update = 'upd',
    Delete = 'del',
  }

  export interface IPerson {
    id: number;
    name: string;
    enabled: boolean;

    phone?: string;
    email?: string;
    surName?: string;
    firstName?: string;
    middleName?: string;

    // FE props.
    fio?: string;
  }

  export interface ICreateAccountPayload {
    persName?: string;
    email: string;
    phone: string;
    corpName: string;

    // Props from account module.
    makePersonFromCorps?: boolean;
    surName?: string;
    firstName?: string;
    middleName?: string;
    corpId?: number;
    id?: number;
    enabled?: boolean;
  }

  export interface IUpdateAccountPayload {
    id: number;
    surName?: string;
    firstName?: string;
    middleName?: string;
    email?: string;
    phone?: string;
    makePersonFromCorps?: boolean;
    enabled?: boolean;
  }

  export interface IPopupPayload {
    createMode: boolean;
    corpId: number;
    corpName: string;
    person?: IPerson;
    closeAction?: Function;
  }

  export enum Events {
    AccountTableCreateItem = 'account-table:create-item',
    AccountTableUpdateItem = 'account-table:update-item',
  }

  export enum StorageKeys {
    TableSortingBy = 'account-table-sorting-prop',
  }
}